<template lang="html">
  <div class="interview-part answer">
    <div class="interview-answer-question set-after">
      <label :for="'question' + this.part.id">Question</label>
      <input type="text" :id="'question' + this.part.id" :data-question-id="this.part.id" class="long-input"
             :name="'questions[' + this.part.id + '][question]'" required v-model="question" v-on:keyup="inputChange">
    </div>
    <div class="interview-answer-text set-after">
      <label :for="'answer' + this.part.id">Answer</label>
      <textarea :name="'questions[' + this.part.id + '][answer]'" :id="'answer' + this.part.id" cols="30" rows="5"
                class="wysiwyg-please long-input">{{ answer }}</textarea>
    </div>
    <div class=" interview-answer-images set-after">
      <label>Related images</label>
      <image-inputs-list :minId="this.part.id * 20"
                         :idCoefficient="20000"
                         :images="this.images"
                         :disabled-video="true"
                         :interviewImages="part.images"
                         @contentUploaded="prepareImagesIds"></image-inputs-list>
    </div>
    <div class="set-after">
      <label :for="'link' + this.part.id">Upload Video (not required)</label>

      <input class="video-path" type="hidden" :name="'questions[' + this.part.id + '][video_path]'"
             :value="videoPath">

      <UploadVideo
          input-name="video_path"
          :url="routeUploadVideo"
          :name="videoName"
          v-model="videoPath"
      />
    </div>
    <input type="hidden" class="answer__images-ids" :name="'questions[' + this.part.id + '][sorted_images_ids]'"
           v-model="imageIds">

    <div class="col-full align-center" v-if="removeIsAvailable">
      <button type="button" class='transparent-button' @click="deleteItem">Delete block</button>
    </div>
  </div>
</template>

<script>
// Component for showing interview in admin dashboard
import UploadVideo from './UploadVideo';

export default {
  props: ['part', 'partsCount', 'routeUploadVideo'],

  components: {
    UploadVideo
  },

  data() {
    return {
      imageIds: null,
      question: '',
      answer: '',
      videoName: '',
      videoPath: '',
      images: {}
    };
  },
  computed: {
    removeIsAvailable: function () {
      return this.partsCount != 1;
    }
  },
  methods: {
    prepareImagesIds(input) {
      let filteredImages = window._.filter(input.content, (input) => {return input.type === 'image';});

      this.imageIds = window._.compact(window._.map(filteredImages, 'imageId'));

      // $(this.$el).find('.interview-answer-images .interview-validation').remove();
    },
    deleteItem() {
      this.$emit('itemDeleted', {
        id: this.part['id']
      });
    },
    inputChange(e) {
      $(this.$el).find('.interview-answer-question .interview-validation').remove();
    },
    prepareExistingImageIds() {
      if (!this.part.images) return;

      this.imageIds = this.part.images.filter(image => image.id).map(image => image.id);
    },
  },
  created() {
    if (this.part['question']) {
      this.question = this.part['question'];
      this.answer = this.part['answer'];
      this.videoName = this.part['video_name'];
      this.images = this.part['images'];
    }
  },
  mounted() {
    CKEDITOR.replace($(this.$el).find('.wysiwyg-please').attr('name'), {
      uiColor: '#dddddd'
    });

    CKEDITOR.instances[$(this.$el).find('.wysiwyg-please').attr('id')].on('change', () => {
      $(this.$el).find('.interview-answer-text .interview-validation').remove();
    });

    this.prepareExistingImageIds();
  }
};
</script>
